import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addstation',
  templateUrl: './addstation.component.html',
  styleUrls: ['./addstation.component.css']
})
export class AddstationComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  stationColl: any = [];
  stationid: number = 0

  stationform = new FormGroup({
    stationid: new FormControl(0),
    stationname: new FormControl('', Validators.required),
    stationcode: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Station";


  @Input() stationname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.stationid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.stationform.reset();
      this.fnInitializeStation();

      if (this.stationid > 0) {
        this.fngetStation();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.stationid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeStation() {
    this.stationform.setValue({

      stationid: 0,
      stationname: '',
      stationcode: null,
      inactive: false,
    })
  }

  //Get 
  fngetStation() {

    var data = {
      'stationid': this.stationid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getStation(data)
      .subscribe(
        (res) => {
          this.stationColl = res.json().result;
          var editdata = this.stationColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.stationform.valid) {
        this.saveloading= true;
        //Check
        var data = {
          'stationid': this.stationid,
          'stationname': this.stationform.get('stationname').value,
          'stationcode': this.stationform.get('stationcode').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.stationform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckStation(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.stationform.get('stationid').value > 0) {
                //Update Department
                this.fnSetStation(data);
              }
              else {
                //Insert Department
                this.fnInsertStation(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading= false;

                this.stationform.controls['stationname'].setErrors({ 'notfound': true });
                this.stationform.controls['stationcode'].setErrors({ 'notfound': true });
              }
             
            }
          },
          (err) => {
            this.saveloading= false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading= false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertStation(data) {

    this.appService.fnInsertStation(data).subscribe(
      (res) => {
        this.saveloading= false;

        if (res.json().result != "") {
          this.toastr.success('', "The New Station has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.stationid);

          this.emitData.emit(this.stationid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading= false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetStation(data) {

    this.appService.fnSetStation(data).subscribe(
      (res) => {
        this.saveloading= false;

        if (res.json().result != "") {
          this.toastr.success('', "The Station has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.stationid, data.station);

          this.emitData.emit(this.stationid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading= false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.stationform.setValue({

      stationid: deptBO.stationid,
      stationname: deptBO.stationname,
      stationcode: deptBO.stationcode,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
